@if (deviceSvc.isMobile) {
  <div class="banner-mobile">
    <img alt="banner" [src]="'app.home.banner-mobile' | i18n" />
    <div class="banner-content">
      <h1 class="inter h2 w700">
        {{ 'app.home.banner-title-1' | i18n }}
        <br>
        {{ 'app.home.banner-title-2' | i18n }}
      </h1>
    </div>
    <div class="controls">
      <a [href]="appleAppLink">
        <button class="apple"
                [style]="appStoreImg">
        </button>
      </a>
      <a [href]="googleAppLink">
        <button class="google"
                [style]="googlePlayImg">
        </button>
      </a>
    </div>
  </div>
} @else {
  <div class="banner-desktop">
    <img alt="banner" [src]="'app.home.banner-desktop' | i18n" />
    <div class="banner-content">
      <h1 class="inter w700">
        {{ 'app.home.banner-title-1' | i18n }}
        <br>
        {{ 'app.home.banner-title-2' | i18n }}
      </h1>
      <div class="controls">
        <a [href]="appleAppLink">
          <button class="apple"
                  [style]="appStoreImg">
          </button>
        </a>
        <a [href]="googleAppLink">
          <button class="google"
                  [style]="googlePlayImg">
          </button>
        </a>
      </div>
    </div>
  </div>
}

